// Account security (W23): the signed-in staff user's own two-factor authentication. The console had no page of
// one's own account; this is it.
import { TwoFactorSettings } from '@qor/web-shared';
import { usePageTitle } from '../components/ConsoleLayout';
import { PageHeading } from '../components/ui';

export function SecurityPage() {
  usePageTitle('Security');
  return (
    <>
      <PageHeading title="Security" trail={[]} />
      <div className="qc-panel" style={{ maxWidth: 720 }}>
        <div className="qc-panel-title">
          <h3>Two-factor authentication</h3>
          <span>A second step when you sign in to the console</span>
        </div>
        <TwoFactorSettings
          classes={{ field: 'qc-field', primary: 'qor-button qor-button-primary', secondary: 'qc-button-ghost' }}
        />
      </div>
    </>
  );
}
